import { useEffect, useState } from 'react';

import useWindowSize from 'hooks/useWindowSize';
import { PRODUCT_CARD_BREAKPOINT_MAX, PRODUCT_CARD_BREAKPOINT_MIN } from 'constants/appConstants';

const AdsRecosRow = ({ WrapperEl = 'div', attributes, className, rowIndex = 1, cardCount, debounceWait = 500, children }) => {
  const [productCardIndex, setProductCardIndex] = useState(null);
  const { width: windowWidth } = useWindowSize(debounceWait);

  useEffect(() => {
    if (windowWidth) {
      const getProductCardIndex = (width, count) => {
        const loc = width <= PRODUCT_CARD_BREAKPOINT_MIN ? 2 : width <= PRODUCT_CARD_BREAKPOINT_MAX ? 3 : 4;
        return count < loc ? count - 1 : rowIndex * loc - 1;
      };

      const cardIndex = rowIndex ? getProductCardIndex(windowWidth, cardCount) : 0;

      const wrapper = document.getElementsByClassName(className)[0];
      if (wrapper && cardIndex !== productCardIndex) {
        const productCardElem = document.querySelectorAll('#products > article')[cardIndex];
        rowIndex ? productCardElem?.after(wrapper) : productCardElem?.before(wrapper);
        setProductCardIndex(cardIndex);
      }
    }
  }, [windowWidth, cardCount, rowIndex, productCardIndex, className]);

  return (
    <WrapperEl className={className} {...attributes}>
      {children}
    </WrapperEl>
  );
};

export default AdsRecosRow;
